import { buildReducer } from '../../../../shared';
import type HardDeleteState from '../../../state/hardDeleteState';
import { hardDeleteCompletedAction } from '../../../actions/data/hardDeleteDataActions';
import {
    hardDeleteClickedAction,
    dismissHardDeleteDialogAction,
    confirmHardDeletePersonasClickedAction,
    cancelHardDeletePersonasClickedAction,
} from '../../../actions/user/deletedItems/hardDeleteActions';

export type { HardDeleteState };

const defaultState: HardDeleteState = {
    isHardDeleteInProgress: false,
    hardDeleteFailed: false,
    showConfirmationDialog: false,
};

export default buildReducer<HardDeleteState>()
    .handle(hardDeleteClickedAction, state => ({
        ...state,
        showConfirmationDialog: true,
    }))
    .handle(confirmHardDeletePersonasClickedAction, state => ({
        ...state,
        isHardDeleteInProgress: true,
    }))
    .handle(cancelHardDeletePersonasClickedAction, state => defaultState)
    .handle(dismissHardDeleteDialogAction, state => defaultState)
    .handleDataAction(
        hardDeleteCompletedAction,
        state => defaultState,
        state => ({ ...defaultState, showConfirmationDialog: true, hardDeleteFailed: true })
    )
    .done(defaultState);
export type { Action } from '../../../../shared';
